import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Card from '../Card/Card.jsx';
import Theme from '../../styles/theme.js';

// Base page layout that all screens should use
export const PageLayout = ({ children }) => (
  <div className="content">
    <Grid fluid>
      <Row>
        <Col lg={12} md={12}>
          {children}
        </Col>
      </Row>
    </Grid>
  </div>
);

// Standard card wrapper for all screens
export const PageCard = ({ 
  title, 
  description, 
  children, 
  fullWidth = true,
  responsive = true,
  style = {},
  ...props 
}) => (
  <div style={{
    minWidth: Theme.layout.cardMinWidth,
    maxWidth: Theme.layout.cardMaxWidth,
    width: Theme.layout.cardWidth,
    marginBottom: Theme.layout.containerMargin,
    ...style
  }}>
    <Card
      title={title}
      category={description ? <p>{description}</p> : null}
      ctTableFullWidth={fullWidth}
      ctTableResponsive={responsive}
      content={children}
      {...props}
    />
  </div>
);

// Container for form content with standard margins
export const FormContainer = ({ children, style = {} }) => (
  <div style={{
    margin: Theme.layout.contentPadding,
    ...style
  }}>
    {children}
  </div>
);

// Standard form row with consistent spacing
export const FormRow = ({ children, style = {} }) => (
  <div style={{
    marginBottom: Theme.spacing.lg, // Increase spacing between controls
    display: 'block',
    ...style
  }}>
    {children}
  </div>
);

// Consistent label styling
export const FormLabel = ({ children, style = {} }) => (
  <label style={{
    width: Theme.layout.labelWidth,
    marginRight: Theme.layout.labelMarginRight,
    fontWeight: Theme.typography.fontWeight.medium,
    textAlign: Theme.layout.labelTextAlign,
    color: Theme.colors.text,
    fontSize: Theme.typography.fontSize.small,
    ...style
  }}>
    {children}
  </label>
);
